import { render, staticRenderFns } from "./batchArrivedOrder.vue?vue&type=template&id=aa02da68&scoped=true"
import script from "./batchArrivedOrder.vue?vue&type=script&lang=js"
export * from "./batchArrivedOrder.vue?vue&type=script&lang=js"
import style0 from "./batchArrivedOrder.vue?vue&type=style&index=0&id=aa02da68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa02da68",
  null
  
)

export default component.exports